import { EPosition } from '@summit/models';
import { Dayjs } from 'dayjs';
import { EboObject } from '../base-classes/ebo-object';
import { State } from './state/state';

export class City extends EboObject {
  name: string;
  stateId: string;
  state: State;
  center: EPosition;
  radius: number;
  NECorner: EPosition;
  SWCorner: EPosition;
  lastGeoLocate: Dayjs;

  constructor(jsonData?: Partial<City>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.state) this.state = new State(jsonData.state);
      if (jsonData.center) this.center = new EPosition(jsonData.center);
      if (jsonData.NECorner) this.NECorner = new EPosition(jsonData.NECorner);
      if (jsonData.SWCorner) this.SWCorner = new EPosition(jsonData.SWCorner);
    }
  }
}
